module.exports = __webpack_public_path__ + "img/18.0694ed49.png";